<template>
    <b-modal id="company-detail-modal"
             :title="modalTitle"
             hide-footer
             size="xl"
             modal-class="default-modal"
             @hide="closeModal"
    >
        <div class="action-btns">
            <template v-if="mode === 'readOnly'">
                <div style="height: 32px"/>
            </template>
            <template v-else-if="mode === 'detail'">
                <b-button variant="outline-primary"
                          @click="changeMode('edit')"
                >
                    {{ $t('수정')}}
                </b-button>
            </template>
            <template v-else-if="mode === 'add'">
                <b-button variant="outline-primary"
                          form="company-form"
                          type="submit"
                >
                    {{ $t('저장')}}
                </b-button>
            </template>
            <template v-else-if="mode === 'edit'">
                <b-button variant="outline-danger">
                    {{ $t('삭제') }}
                </b-button>
                <b-button variant="outline-primary"
                          form="company-form"
                          type="submit"
                >
                    {{ $t('저장') }}
                </b-button>
                <b-button variant="outline-secondary"
                          @click="changeMode('detail')"
                >
                    {{ $t('취소') }}
                </b-button>
            </template>
        </div>
        <div class="tabs-container">
            <b-tabs class="default-tabs" :class="{'with-actions': mode !== 'add'}" content-class="mt-3">
                <b-tab  v-model="tabIndex" :title="$t('기본 정보')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <CompanyDetail v-if="mode === 'detail'" :detail-data="detailData"/>
                        <CompanyForm v-else ref="companyForm" :mode="mode" :detail-data="detailData"
                                     @updateDetailData="updateDetailData"
                        />
                    </template>
                </b-tab>
                <b-tab v-if="mode === 'detail' || readOnly" :title="$t('소속 유저')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <CompanyMembers :members="detailData.member"
                                        :company="detailData"
                                        :readOnly="readOnly"
                                        @updateMember="updateMember"
                        />
                    </template>
                </b-tab>
                <b-tab v-if="mode === 'detail' || readOnly" :title="$t('평가 참여 정보')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <AdminCompanyAssessmentInfo :selected_company="detailData"
                                                    :readOnly="readOnly"
                                                    
                        />
                    </template>
                </b-tab>
            </b-tabs>
        </div>
    </b-modal>
</template>

<script>
import CompanyDetail from '@shared/components/admin/pages/Management/Company/_SubComponent/CompanyDetail.vue';
import CompanyForm from '@shared/components/admin/pages/Management/Company/_SubComponent/CompanyForm.vue';
import CompanyMembers from '@shared/components/admin/pages/Management/Company/_SubComponent/CompanyMembers.vue';
import AdminCompanyAssessmentInfo
    from '@shared/components/admin/pages/Management/Company/_SubComponent/AssessmentInfo.vue';

export default {
    name: 'CompanyModal',
    components: {
        AdminCompanyAssessmentInfo,
        CompanyMembers,
        CompanyForm,
        CompanyDetail,
    },
    props: {
        detailId: {
            type: [Number, String, null],
            default: null,
        }
    },
    data() {
        return {
            mode: 'detail', // detail | add | edit | readOnly
            tabIndex: 1,
            detailData: {id: null},
            loading: false,
        };
    },
    computed: {
        modalTitle() {
            if (this.mode === 'add') {
                return this.$t('기업 등록');
            } else if (this.mode === 'edit') {
                return this.$t('기업 수정');
            } else {
                return this.$t('기업 상세');
            }
        },
        readOnly(){
            return this.mode === 'readOnly';
        }
    },
    watch: {
        detailId: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.fetchDetailData();
                } else {
                    this.detailData = {id: null};
                }
            }
        }
    },
    methods: {
        changeMode(mode) {
            this.mode = mode;
            this.tabIndex = 1;
        },
        closeModal() {
            if (this.mode === 'edit') {
                this.$refs.companyForm.resetForm();
            }
            this.mode = 'detail';
            this.$bvModal.hide('company-detail-modal');
        },
        updateDetailData(detailData) {
            this.$emit('updateDetailData', detailData);
            if(this.mode === 'add'){
                this.closeModal();
            }
            else if(this.mode === 'edit'){
                this.changeMode('detail');
            }
        },
        async fetchDetailData(){
            try {
                this.loading = true;
                
                const _res_company_info = await this.$axios.get(`/admin/company/${this.detailId}/info`);
                const {company, member, projects} = _res_company_info.data;
                const {company_name, company_code, company_address, company_tel, client, country} = company;
                this.detailData = {
                    company_id: this.detailId, company_name, company_code, company_address, company_tel, client,country,
                    member: member.map((item,index) => ({...item, index})), projects
                };
            }
            catch (e) {
                console.error(e);
                console.dir(e);
            }
            finally {
                this.loading = false;   
            }
        },
        updateMember(updatedUser){
            const idx = this.detailData.member.findIndex((item) => {
                return item.user_id === updatedUser.id;
            });
            this.$set(this.detailData.member, idx, updatedUser);
        }
    },
};
</script>

<style scoped lang="scss">

</style>
